import { all } from "redux-saga/effects";
import { watchAuth } from "./slices/auth/authSaga";
import { watchFetchEmployees } from "./slices/employee/employeeSaga";
import { watchFetchClients } from "./slices/client/clientSaga";
import { watchFetchVendors } from "./slices/vendor/vendorSaga";
import { watchFetchWorkauths } from "./slices/workauths/workauthsSaga";
import { watchFetchPlacements } from "./slices/placements/placementsSaga";
import { watchFileUpload } from "./slices/universal/fileUploadSaga";
import { watchDocuments } from "./slices/universal/documentsSaga";
import { watchTimesheets } from "./slices/timesheets/timesheetSaga";
import { watchTotalCount } from "./slices/totalCount/totalCountSaga";
import { watchFetchImmigration } from "./slices/immigration/immigrationSaga";
import { watchFetchAllDocuments } from "./slices/document/documentSaga";
import { watchAccountPaybles } from "./slices/accountPayables/accountPayablesSaga";
import { watchFetchInvoices } from "./slices/invoices/invoicesSaga";
import { watchFetchPayRoll } from "./slices/payroll/payrollSaga";
import { watchQuickBooksApi } from "./slices/quickBooks/quickBooksSaga";
import { watchFetchReconciliations } from "./slices/reconciliation/reconciliationgSaga";

// import { watchLeadSagas } from "./slices/leads/leadSaga";

// import { bdmJobsSaga} from "./slices/bdmjobs/bdmjobsSaga";
import { watchFetchAccountDetails } from "./slices/accountDetails/accountDetailsSaga";
import { watchFetchLeadsSaga } from "./slices/leads/leadSaga";
import { watchFetchClientSubmissions } from "./slices/bdmjobs/bdmjobsSaga";

import { watchCompaigns } from "./slices/compaigns/compaignsSaga";
import { watchSourcing } from "./slices/recruitmentSourcing/SourcingSaga";
import { watchSettingSaga } from "./slices/setting/settingSaga";
import { watchSignatureSaga } from "./slices/signatures/signaturesSaga";
import { watchFetchApplicantsInternalDB } from "./slices/internalDbES/internalDbESSags";
import {
  watchBenchSales,
  watchKultFetch,
} from "./slices/ats/benchSales/benchSalesSaga";
import { watchNonitMarketing } from "./slices/nonitMarketing/nonitMarketingSaga";
import { watchReportsSaga } from "./slices/reports/reportsSaga";
import { watchJobs } from "./slices/jobs/jobsSaga";
import { watchFetchAtsDashboard } from "./slices/atsDashboard/atsDashboardSaga";
import { watchHotlist } from "./slices/ats/hotlistSaga";
import { watchBsReportsSaga } from "./slices/reports/bsReportsSaga";
import { watchIncentives } from "./slices/incentives/incentiveSaga";
import { watchIpRestrictions } from "./slices/ip/ipSaga";
import { watchNMHotlist } from "./slices/nonitMarketing/hotlist/hotlistSaga";
import { watchNMJobs } from "./slices/nonitMarketing/jobs/JobsSaga";
import { watchEmailLog } from "./slices/emaillogs/emaillogsSaga";

export default function* rootSaga() {
  yield all([
    watchAuth(),
    watchFetchEmployees(),
    watchFetchClients(),
    watchFetchWorkauths(),
    watchFetchVendors(),
    watchFetchPlacements(),
    watchFileUpload(),
    watchDocuments(),
    watchTimesheets(),
    watchTotalCount(),
    watchFetchImmigration(),
    watchFetchAllDocuments(),
    watchAccountPaybles(),
    watchFetchInvoices(),
    watchFetchPayRoll(),
    watchQuickBooksApi(),
    watchFetchReconciliations(),
    watchFetchLeadsSaga(),
    watchFetchAccountDetails(),
    watchFetchClientSubmissions(),
    watchCompaigns(),
    watchSourcing(),
    watchSettingSaga(),
    watchSignatureSaga(),
    watchFetchApplicantsInternalDB(),
    watchKultFetch(),
    watchReportsSaga(),
    watchBsReportsSaga(),
    watchBenchSales(),
    watchJobs(),
    watchFetchAtsDashboard(),
    watchHotlist(),
    watchIncentives(),
    watchIpRestrictions(),
    watchNonitMarketing(),
    watchNMHotlist(),
    watchNMJobs(),
    watchEmailLog(),
  ]);
}
